import { ZodShipmentStatus } from '@rotra-air-ocean/rotranext-shared-code';

import {
  BookingStep,
  BookingStepUrls,
} from '$components/pages/single_channel_booking/BookingStep';
import { TabTypes } from '../components/pages/developer/DeveloperPage';
import { SubPageTypes } from '../components/pages/developer/pages/GuidesPage';

const PATHS = {
  dashboard: {
    root: '/',
  },
  activate_user: {
    root: (userId: string) => `/activate-user/${userId}`,
    finish: `/finished`,
  },
  bookings: {
    root: `/bookings`,
    details: (id: string) => `/bookings/${id}`,
    new_from_request: '/bookings/requests/new',
  },
  shipments: {
    root: `/shipments`,
    overview: (status?: ZodShipmentStatus) =>
      `/shipments${status ? `?status=${status}` : ''}`,
    details: (id: string) => `/shipments/${id}`,
    tasks: (id: string) => `/shipments/${id}#tasks`,
    shared: (guid: string) => `/shared/shipment/${guid}`,
  },
  contracts: {
    root: `/contracts`,
    details: (id: string) => `/contracts/${id}`,
  },
  quotes: {
    root: '/quotes',
    spot_rates: {
      root: `/quotes/spot-rates`,
      details: (id: string) => `/quotes/spot-rates/${id}`,
      book: (id: string) => `/quotes/spot-rates/${id}/book`,
    },
    quote_requests: {
      root: `/quotes/quote-requests`,
      new: '/quotes/quote-requests/new',
      details: (id: string) => `/quotes/quote-requests/${id}`,
    },
  },
  orders: {
    root: `/orders`,
    details: (id: string) => `/orders/${id}`,
  },
  booking_1_channel: {
    root: '/bookings/new',
    step: (step: BookingStep = BookingStep.GENERAL) =>
      `/bookings/new/step/${BookingStepUrls[step]}`,
    step_route: '/bookings/new/step/:id',
  },
  release_notes: {
    root: '/whats-new',
    details: (id: string) => `/whats-new/${id}`,
  },
  addressbook: {
    root: '/addressbook',
    new: '/addressbook/new',
    details: (id: string) => `/addressbook/${id}`,
    view: (id: string) => `/addressbook/${id}/view`,
  },
  reporting: {
    root: '/reporting',
    tab: (tab: string) => `/reporting/${tab}`,
  },
  messaging: {
    root: '/messages',
  },
  tasks: {
    root: '/tasks',
  },
  terms_of_use: {
    root: '/terms-of-use',
  },
  calendar: {
    root: '/calendar',
  },
  developer: {
    root: '/developer',
    tab: (tab: TabTypes) => `/developer/${tab}`,
    guides: (slug: SubPageTypes) => `${PATHS.developer.tab('guides')}/${slug}`,
    apiAccess: (clientId?: string) =>
      clientId
        ? `${PATHS.developer.tab('api-access')}/${clientId}`
        : PATHS.developer.tab('api-access'),
  },
  organizations: {
    root: '/organizations',
    details: (id: string) => `/organizations/${id}`,
  },
  profile: {
    settings: '/profile/settings',
    section: (section: string) => `/profile/${section}`,
    subsection: (section: string, subsection: string) =>
      `/profile/${section}/${subsection}`,
  },
  not_found: {
    root: '/not-found',
  },
  internal: {
    // Super admins only
    features: '/features',
    // Super admins and Entra ID users
    styles: {
      colors: '/styles/colors',
      action_colors: '/styles/action-colors',
      alert_colors: '/styles/alert-colors',
      typography: '/styles/typography',
      section: (section: string) => `/styles/${section}`,
    },
  },
};

export default PATHS;
